import { render, staticRenderFns } from "./walletDetail.vue?vue&type=template&id=1ae1a3f4&"
import script from "./walletDetail.vue?vue&type=script&lang=js&"
export * from "./walletDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports